'use client'

import { useState } from "react"
import Link from "next/link"
import clsx from "clsx"
import chunk from "lodash/chunk"
import sortBy from "lodash/sortBy"

import { Section } from "../Section/Section"
import { Hx } from "@/stories/atoms/Hx/Hx"
import { Grid } from "../Grid/Grid"
import { Card } from "@/stories/components/Card/Card"
import { RichText } from "@/stories/atoms/RichText/RichText"
import { Button } from "@/stories/atoms/Button/Button"

export type RowType = {
  name?: string,
  code?: string,
  child: {
    name: string,
    code: string
    url: string,
    text: string
  }[]
}

export const CardRowSection = (
  {
    row,
    title
  }: {
    row: RowType,
    title: string,
  }) => {
  const [index, setIndex] = useState<number>(0)
  const chunkRow = chunk(sortBy(row.child, 'name'), 32)

  return (
    <Section background='grey-light'>
      <Hx headingLevel='h2'>{title}</Hx>
      <Grid nbCols={1}>
        {chunkRow.map((item, i) => (
          <CardRow
            key={i}
            items={item}
            slicleIndex={i}
            isLast={i === chunkRow.length -1}
            hidden={i > index}
            setIndex={setIndex}
            currentIndex={index}/>
        ))}
      </Grid>
    </Section>
  )
}

const CardRow = ({
  items,
  slicleIndex,
  isLast,
  currentIndex,
  setIndex,
  hidden,
}: {
  items: RowType['child'],
  slicleIndex: number,
  hidden: boolean,
  isLast: boolean,
  currentIndex: number,
  setIndex: (index: number) => void,
}) => {
  return (
    <Grid nbCols={4} className={clsx(hidden && 'hide')} key={slicleIndex}>
      {items.map(child => <CardLink key={child.name} name={child.name as string} text={child.text} link={child.url}/>)}
      {!isLast && (slicleIndex >= currentIndex) ? (
        <Button onClick={() => setIndex(slicleIndex + 1)}>
          Plus de villes
        </Button>
      ) : null}
    </Grid>
  )
}

type CardLinkType = {name: string, text: string, link: string}

export const CardLink = ({name, text, link}: CardLinkType) => {

  return (
    <Card border={true} asChild key={name} padding='l'>
      <Link href={link}>
        <Hx headingLevel='h3' styleLevel='h4'>{name}</Hx>
        <RichText className='text-s'>{text}</RichText>
      </Link>
    </Card>
  )
}